import { Exclude } from 'class-transformer';
import { BaseItem } from './base-item.model';

interface LocationAttributes {
  alias: string;
  name: string;
  type: string;
}

@Exclude()
export class Location extends BaseItem<LocationAttributes> {}
